var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", { staticClass: "job-search-page" }, [
    _c(
      "div",
      { staticClass: "menu-buttons bg-white d-flex mt-4 pl-2 rounded-top" },
      [
        _c(
          "div",
          {
            staticClass: "menu-item m-3 m-sm-4 mb-0",
            class: _vm.selectedMenu === "SearchPage" ? "active" : "",
            on: {
              click: function ($event) {
                return _vm.selectMenu("SearchPage")
              },
            },
          },
          [
            _c("div", { staticClass: "d-flex align-items-center pb-1" }, [
              _vm._v(_vm._s(_vm.t.jobSearch_V2_Jobsearch)),
            ]),
          ]
        ),
        _vm.savedSearchesRetrieved === true
          ? _c(
              "div",
              {
                staticClass: "menu-item m-3 m-sm-4 mb-0",
                class: _vm.selectedMenu === "SavedSearchesPage" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.selectMenu("SavedSearchesPage")
                  },
                },
              },
              [
                _c("div", { staticClass: "d-flex align-items-center pb-1" }, [
                  _vm._v(
                    _vm._s(_vm.t.jobSearch_V2_Saved_Searches) +
                      " (" +
                      _vm._s(_vm.savedSearches.length) +
                      ")"
                  ),
                ]),
              ]
            )
          : _c(
              "div",
              { staticClass: "menu-item m-3 m-sm-4 mb-0" },
              [_c("b-skeleton", { attrs: { width: "150px" } })],
              1
            ),
      ]
    ),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selectedMenu === "SearchPage",
            expression: "selectedMenu === 'SearchPage'",
          },
        ],
      },
      [
        _c("TopSearch", {
          attrs: {
            userInfo: _vm.userInfo,
            selectedJobPosting: _vm.selectedJobPosting,
            mobileFiltersIsOpen: _vm.mobileFiltersIsOpen,
            startedSearch: _vm.startedSearch,
            jobsFromPartners: _vm.jobsFromPartners,
            canSaveSearch: _vm.canSaveSearch,
            searchParams: _vm.searchParams,
            settings: _vm.settings,
          },
          on: {
            startSearch: function ($event) {
              return _vm.startSearch(true, false)
            },
            changeShowOverlay: function ($event) {
              return _vm.changeShowOverlay($event)
            },
            changeMobileFiltersIsOpen: function ($event) {
              return _vm.changeMobileFiltersIsOpen($event)
            },
            openSaveSearchModal: function ($event) {
              return _vm.openSaveSearchModal()
            },
            clearSearch: function ($event) {
              return _vm.clearSearch()
            },
            emitParams: function ($event) {
              return _vm.emitParams()
            },
          },
        }),
        _vm.searchCompleted === true
          ? _c(
              "b-row",
              {
                staticClass:
                  "d-flex justify-content-center text-brand-medium mt-4 mb-3",
              },
              [
                _vm.jobResult !== undefined
                  ? [
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.jobResult.TotalResults) + " "),
                      ]),
                      _vm.jobResult.Type === "fromDataBase"
                        ? _c("h4", [
                            _vm._v(
                              _vm._s(
                                _vm.t.jobSearch_V2_Search_Is_From_Database_Text
                              )
                            ),
                          ])
                        : _vm.jobResult.Type === "firstVisit"
                        ? _c("h4", [
                            _vm._v(
                              _vm._s(
                                _vm.t.jobSearch_V2_Search_Is_First_Visit_Text
                              )
                            ),
                          ])
                        : _c("h4", [
                            _vm._v(
                              _vm._s(_vm.t.jobSearch_V2_Search_Is_Normal_Text)
                            ),
                          ]),
                    ]
                  : [
                      _c("h4", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.jobsFromPartners === false
                              ? _vm.t.jobSearch_V2_No_Search_Result
                              : _vm.t.jobSearch_V2_No_Search_Result_Partners
                          )
                        ),
                      ]),
                    ],
              ],
              2
            )
          : _vm._e(),
        _c("JobViewContainer", {
          attrs: {
            jobPostings: _vm.jobPostings,
            activeIndex: _vm.activeIndex,
            selectedJobPosting: _vm.selectedJobPosting,
            useSavedAdvert: false,
          },
          on: {
            setActiveIndex: function ($event) {
              return _vm.setActiveIndex($event)
            },
            setSelectedJobPosting: function ($event) {
              return _vm.setSelectedJobPosting($event)
            },
            searchForMore: function ($event) {
              return _vm.searchForMore()
            },
          },
        }),
        _vm.startedSearch ? _c("JobResultSkeleton") : _vm._e(),
        _c(
          "b-modal",
          {
            attrs: {
              id: "modal-1",
              "body-bg-variant": "primary",
              "hide-footer": "",
              "hide-header": "",
            },
          },
          [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.saveSearch()
                  },
                },
              },
              [
                _c("div", { staticClass: "modal-top-line p-1" }),
                _c(
                  "div",
                  {
                    staticClass:
                      "modal-top d-flex justify-content-between text-white px-4 pt-4 align-items-center",
                  },
                  [
                    _c("h2", [_vm._v(_vm._s(_vm.t.jobSearch_V2_Save_Search))]),
                    _c("b-icon", {
                      staticClass: "clickable",
                      attrs: { icon: "x", variant: "white", "font-scale": "3" },
                      on: {
                        click: function ($event) {
                          return _vm.closeSaveSearchModal()
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "modal-middle px-4 pt-2 pb-4" },
                  [
                    _c("b-input", {
                      class:
                        _vm.foundSavedWithSameName === true
                          ? "border border-danger"
                          : "",
                      attrs: {
                        placeholder: _vm.t.jobSearch_V2_Name_Your_Search,
                        autofocus: "",
                      },
                      model: {
                        value: _vm.savedSearchName,
                        callback: function ($$v) {
                          _vm.savedSearchName = $$v
                        },
                        expression: "savedSearchName",
                      },
                    }),
                    _vm.foundSavedWithSameName === true
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "text-danger font-weight-bold mt-1 d-flex",
                          },
                          [
                            _vm._v(
                              "* " +
                                _vm._s(_vm.t.jobSearch_V2_Name_Is_Not_Unique)
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "modal-bottom d-flex" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "w-100",
                        attrs: {
                          block: "",
                          variant: "primary",
                          disabled: _vm.savedSearchName === "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.saveSearch()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.t.jobSearch_V2_Save_Search))]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm.savedMenuClicked
      ? _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selectedMenu === "SavedSearchesPage",
                expression: "selectedMenu === 'SavedSearchesPage'",
              },
            ],
          },
          [
            _c("JobSavedSearches", {
              attrs: { savedSearchesRetrieved: _vm.savedSearchesRetrieved },
              on: {
                deleteSavedSearch: function ($event) {
                  return _vm.deleteSavedSearch($event)
                },
                startSearch: function ($event) {
                  return _vm.startSearch(true, true)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }